export default __webpack_public_path__ + "fonts/WarnerBrosSans-Regular.ttf";